import createPdf from './pdf';
import configUiCallback, { getAssetsUrl } from './config';

// certain structure is requried when adding new product
// each product must have a thumbnailUrl and products attr to work properly
// missing thumbnailUrl will use the default image (Image not found) as thumbnail
// missing products will cause the thumbnail rendered as disabled
// product can have multi level subproduct as long as the same structure is followed

export const PRODUCTS = {
  name: 'PRODUCTS',
  products: {
    'Extrudeck-100-Series': {
      thumbnailUrl: getAssetsUrl(['image', 'Extrudeck-100-series.png']),
      name: 'Extrudeck-100-Series',
      products: {
        'Extrudeck-100': {
          name: 'Extrudeck-100',
          thumbnailUrl: getAssetsUrl(['image', 'Extrudeck-100.png']),
          products: {
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-101': {
          name: 'Extrudeck-101',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-101.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22IND%20LT%208%20(S)%22,%22Crowns%22:%22None%22,%22Lighting%22:%22LD-5%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F57d7dddf2e9816911bc74fa6707c22c3%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-102': {
          name: 'Extrudeck-102',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-102.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22CURVED%22,%22Crowns%22:%22None%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fc50e73f5fbba39bfcd9b17bac29dbad6%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-103': {
          name: 'Extrudeck-103',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-103.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22IND%20LT%20FP%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fb7ff152ca4b5eb88674b4b76bf29665c%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png ',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-104': {
          name: 'Extrudeck-104',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-104.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22IND%20LT%2016%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F2e8db6eaf40f386cfbd280784874ecb4%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-105': {
          name: 'Extrudeck-105',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-105.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22IND%20HB%22,%22Crowns%22:%22QTR%20(RP)%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F8198ce255d5cb97ec8073d18fea81d60%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-106': {
          name: 'Extrudeck-106',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-106.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22None%22,%22Crowns%22:%22BC-%204%20(P)%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F02f350f0729891f9f72aae830db9c30b%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-107': {
          name: 'Extrudeck-107',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-107.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22IND%20LT%208%20(S)%22,%22Crowns%22:%22None%22,%22Lighting%22:%22LD-11%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F345e910ea695e22dbeb1e3ab4d951f9c%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-108': {
          name: 'Extrudeck-108',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-108.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22None%22,%22Crowns%22:%22BC-%204%20(S)%22,%22Lighting%22:%22LD-5%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F37f5e2fb45a9335f7cb0aa9093117973%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-109': {
          name: 'Extrudeck-109',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-109.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22B3%22,%22Crowns%22:%22DB%20RP%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F34c32bbb44429a34b87e9733617c1fe3%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-110': {
          name: 'Extrudeck-110',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-110.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22IND%20HB%22,%22Crowns%22:%22C-%205%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fdba598ad5abb9804506b21317d15e416%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
        'Extrudeck-111': {
          name: 'Extrudeck-111',
          thumbnailUrl: getAssetsUrl(
            //mythreekit productId // configurator form name
            ['image', 'Extrudeck-111.png']
          ),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Extrudeck-100-Series/Extrudeck-100?configuration={%22Mounting%22:%22Hanger%20Rod%20Supported%22,%22Escutcheon%20Plates%22:%226%20SQU%20(S)%22,%22Drainage%22:%22Diverter%20(S)%22,%22Obscurity%20Screen%22:false,%22Profiles%22:%22CONT%201%22,%22Crowns%22:%22BC-%204%20(P)%22,%22Lighting%22:%22None%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F79309a5d84aa8f8d655939b81bc80525%3Ffilename%3DExtrudeck%20Master%20Model%20WebGL%20Render.png',
            sceneId: 'c70857a1-5407-4d55-ba7d-ae700585e91e',
            publishedHash: '0f0d0dfe7c61931d5f4af8d4f74220eb',
            productId: '5b0f09fae036250001c9dcbd',
            form: 'Form2',
            pdf: createPdf.Extrudeck,
            configUiCallback: configUiCallback.Extrudeck,
          },
        },
      },
    },
    'Ecoshade-200-Series': {
      name: 'Ecoshade-200-Series',
      thumbnailUrl: getAssetsUrl(
        //mythreekit productId // configurator form name
        ['image', 'Ecoshade-200-series.png']
      ),
      products: {
        'Ecoshade-200': {
          name: 'Ecoshade-200',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-200.png']),
          products: {
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-201': {
          name: 'Ecoshade-201',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-201.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-201?configuration={%226%5C%22%20Profiles%20%22:%22None%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%226%5C%22%20Crowns%20%22:%22None%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Closed%20Frame%22:%226R6ZB%22}&ogImage=https://cdn.threehub.com/resources/f6d57fda5d70fa5b23f183882c2ffd23?filename=Eco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-202': {
          name: 'Ecoshade-202',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-202.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%226%5C%22%20Profiles%20%22:%22indlt12%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Closed%20Frame%22:%226R4AF%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fedb7fb3bd538ea834f4494d876d64084%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-203': {
          name: 'Ecoshade-203',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-203.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%226%5C%22%20Profiles%20%22:%22b2%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%226%5C%22%20Crowns%20%22:%22None%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Closed%20Frame%22:%226R4AF%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Ffaa622a9bc498279e581da9866e435a1%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-204': {
          name: 'Ecoshade-204',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-204.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%226%5C%22%20Profiles%20%22:%22None%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%226%5C%22%20Crowns%20%22:%22qtrs%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F78605181eabead88a908c781caf81456%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-205': {
          name: 'Ecoshade-205',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-205.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%226%5C%22%20Profiles%20%22:%22None%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%226%5C%22%20Crowns%20%22:%22c5%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F53fe021affd208df0dbcd486440a0eef%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-206': {
          name: 'Ecoshade-206',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-206.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%226%5C%22%20Profiles%20%22:%22b1%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%226%5C%22%20Crowns%20%22:%22qtrrp%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fb8b1aa9e259a7f6e0ee2e74d11436f67%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-207': {
          name: 'Ecoshade-207',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-207.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%226%5C%22%20Profiles%20%22:%22cont1%22,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Closed%20%5C%22C%5C%22%20Channel%22,%226%5C%22%20Crowns%20%22:%22bc4s%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2F6943aedc33e341f9f45bb814f14ab47a%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-208': {
          name: 'Ecoshade-208',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-208.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%22Extended%20Infills%22:false,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Open%20w/%20Round%20Nosing%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Open%20Frame%22:%226T4AF%20F%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fe73a418a37ee2cb375444e5f68ef5c78%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-209': {
          name: 'Ecoshade-209',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-209.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%22Extended%20Infills%22:true,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Open%20w/%20Round%20Nosing%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Open%20Frame%22:%226T4AF%20E%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Fb99b40ee5a59ee82dc41a38d302f7fce%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-210': {
          name: 'Ecoshade-210',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-210.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%22Extended%20Infills%22:false,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Open%20w/%20Round%20Nosing%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Open%20Frame%22:%226T6ZB%20F%22}&ogImage=https://cdn.threehub.com/resources/27203f75ed36f2b797bd689f55137af1?filename=Eco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
        'Ecoshade-211': {
          name: 'Ecoshade-211',
          thumbnailUrl: getAssetsUrl(['image', 'Ecoshade-211.png']),
          products: {
            configLink:
              'https://masa.mythreekit.com/configure/Ecoshade-200-Series/Ecoshade-200?configuration={%22Extended%20Infills%22:true,%22Mounting%22:%22Cantilevered%22,%22Frame%20Type%22:%22Open%20w/%20Round%20Nosing%22,%22Outriggers%20ANDPLACEHOLDER%20Infills-%20Open%20Frame%22:%226T6ZB%20E%22}&ogImage=https%3A%2F%2Fcdn.threehub.com%2Fresources%2Ff08ba488ca74391a14709cae046cc7e1%3Ffilename%3DEco-shade%20Master%20Model%20WebGL%20Render.png',
            sceneId: '45273521-0e26-4b9c-b146-4b4cdf5ee398',
            publishedHash: '831813e53c568b37774bd12d9f65b9e5',
            productId: '5b0f0a16e036250001c9dcbf',
            form: 'Form1',
            pdf: createPdf['Ecoshade'],
            configUiCallback: configUiCallback['Ecoshade'],
            configOnchange: function(attr, name) {
              console.log(attr, name);
            },
          },
        },
      },
    },
    'Vision-300-Series': {
      name: 'Vision-300-Series',
      thumbnailUrl: getAssetsUrl(['image', 'Vision-300-series.png']),
      products: {
        'Vision-301': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-301.png']),
          products: {
            name: 'Vision-301',
            sceneId: 'bbcf5c1a-1ece-430a-8c2b-e22a9aae855f',
            publishedHash: 'ff874cef899433e117a192d6a90347d5',
            productId: '5b0f0a41e036250001c9dcc1',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-302': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-302.png']),
          products: {
            name: 'Vision-302',
            sceneId: '88d07b4b-d2ac-4200-b496-ddc8d10d93ae',
            publishedHash: '91e0efa7384e834b5fc5f4e752509216',
            productId: '5b0f0a4fe036250001c9dcc3',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-303': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-303.png']),
          products: {
            name: 'Vision-303',
            sceneId: '290b1d33-1e2c-41c7-bf89-5731efc74eaf',
            publishedHash: '2deb0e79608b73c88f3d20c2c5735c86',
            productId: '5b2abf77b70942000171db72',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-304': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-304.png']),
          products: {
            name: 'Vision-304',
            sceneId: '27d69901-50b6-493b-99a4-1fc5a7a9a69e',
            publishedHash: '81b16c15b312eaf1606b2ba7ff7371ed',
            productId: '5b2abfeab70942000171db74',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-305': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-305.png']),
          products: {
            name: 'Vision-305',
            sceneId: '36a5cd96-ab61-4fa5-9eb5-d67176900670',
            publishedHash: '1e1c78b2a5231dd2d1684ba38f2f029c',
            productId: '5b2ac027b70942000171db76',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-306': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-306.png']),
          products: {
            name: 'Vision-306',
            sceneId: 'e57ae97d-cd33-414e-b953-458fad2da68b',
            publishedHash: 'fc1acafe166a86d67c7a6174eea022ac',
            productId: '5b2ac064b70942000171db78',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-307': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-307.png']),
          products: {
            name: 'Vision-307',
            sceneId: '96631171-9632-4bbd-903d-668e9a547df3',
            publishedHash: 'e9ab454c53627ff143db446f086c3a55',
            productId: '5b2ac0aab70942000171db7a',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-308': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-308.png']),
          products: {
            name: 'Vision-308',
            sceneId: 'b9624324-53bc-4913-b104-3a50d232acc4',
            publishedHash: '9a52a1a350d3549bb5b2825210bda272',
            productId: '5b2ac195b70942000171db7d',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-309': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-309.png']),
          products: {
            name: 'Vision-309',
            sceneId: '5248b662-0010-4278-a8c0-37b8db821e56',
            publishedHash: '67e82c496a2088c1be0a4a36750bdc41',
            productId: '5b2ac1e4b70942000171db80',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-310': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-310.png']),
          products: {
            name: 'Vision-310',
            sceneId: '749008fb-4aa5-41d8-8752-4731a39c0934',
            publishedHash: 'c69572ad3f8a2d553c588245757c60a6',
            productId: '5b2ac243b70942000171db82',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-311': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-311.png']),
          products: {
            name: 'Vision-311',
            sceneId: '32d52176-6938-482b-82d7-92afac28ef76',
            publishedHash: 'ebda8e2cda79c1322344f9441c54be89',
            productId: '5b2ac25cb70942000171db84',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
        'Vision-312': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-312.png']),
          products: {
            name: 'Vision-312',
            sceneId: '7dfeec3a-04ba-4d24-ac03-c6cb708f6c95',
            publishedHash: '6f8104892f26a8db184e2499661f8ef3',
            productId: '5b2ac28ab70942000171db86',
            form: 'Default',
            pdf: createPdf['Vision-300-series'],
            configUiCallback: configUiCallback['Vision-300-series'],
          },
        },
      },
    },
    'Vision-400-Series': {
      thumbnailUrl: getAssetsUrl(['image', 'Vision-400-series.png']),
      name: 'Vision-400-Series',
      products: {
        'Vision-401': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-401.png']),
          products: {
            name: 'Vision-401',
            sceneId: 'f4dbd3c3-4047-4bf6-aeca-0fb1c5e0c119',
            publishedHash: '743fa32f081c0b8f5853471fc7aaf6c9',
            productId: '5b0f0a61e036250001c9dcc5',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 401'],
          },
        },
        'Vision-402': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-402.png']),
          products: {
            name: 'Vision-402',
            sceneId: '102cf56a-c08f-4e92-9695-373b7a584922',
            publishedHash: 'c744369c6a5280c30b8c8d427d5b2152',
            productId: '5b2ac2ccb70942000171db88',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 402'],
          },
        },
        'Vision-403': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-403.png']),
          products: {
            name: 'Vision-403',
            sceneId: '5786263a-8abf-49fe-b440-09aca41ecf91',
            publishedHash: '0415091aadac341b009d4dab4ef92f73',
            productId: '5b2ac2efb70942000171db8a',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 403'],
          },
        },
        'Vision-404': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-404.png']),
          products: {
            name: 'Vision-404',
            sceneId: '4eaf3449-efbe-44e7-8b9a-e34f6958dd77',
            publishedHash: '1833929e050862136bfa495e7812f0c5',
            productId: '5b2ac31bb70942000171db8c',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 404'],
          },
        },
        'Vision-405': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-405.png']),
          products: {
            name: 'Vision-405',
            sceneId: '1d7ee38b-3cb7-4491-b6d5-48e15b5f37e9',
            publishedHash: '1966ce9212fe1f40ec122fb7a57642dc',
            productId: '5b2ac339b70942000171db8e',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 405'],
          },
        },
        'Vision-406': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-406.png']),
          products: {
            name: 'Vision-406',
            sceneId: '7d04c736-ce1f-4610-b784-693c22c78a8d',
            publishedHash: '22aeac75da7e996570385f1d8c631797',
            productId: '5b2ac353b70942000171db90',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 406'],
          },
        },
        'Vision-407': {
          thumbnailUrl: getAssetsUrl(['image', 'vision-407.png']),
          products: {
            name: 'Vision-407',
            sceneId: 'bc23c74d-4cc5-437b-b0c8-6ff09bb76850',
            publishedHash: 'af8d27707afb55807cd1a2fd8d68d11d',
            productId: '5b2ac36eb70942000171db92',
            form: 'Default',
            pdf: createPdf['Vision-400-series'],
            configUiCallback: configUiCallback['Vision 407'],
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/constants.js